export default __webpack_public_path__ + "static/media/dtsu5168_ct_master_4p.67bdea27.png";